
// usage like: 
// >> import date from "@/date";
// >> date.getShortDay(dt);
// returns: "mon"

const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]

var date = {
    getShortDay(dt) {
        if (dt) { return days[dt.getDay()] }
        else return days[new Date().getDay()] // if null passed in return now day
    },
    getHHMM() {
        // could pass in server time here to be safe, in case device time is wrong
        // should also pass in the desired timezone to convert from UTC
        var hours = this.padZero(new Date().getHours()); // should use getUTCHours() here
        var minutes = this.padZero(new Date().getMinutes());
        return `${hours}${minutes}`
    },
    padZero(i) {
        if (i < 10) i = "0" + i;
        return i;
    }
}

export default date